/** A failed request, stated in one line. No illustration, no advice. */
import { foutBericht } from '@/lib/api/client';

export function Melding({ fout }: { fout: unknown }) {
  return (
    <p className="border border-brick/40 bg-surface-strong px-2.5 py-1.5 text-[12px] text-brick">
      {foutBericht(fout)}
    </p>
  );
}
